import React, { useContext, useState } from 'react';

import TealiumEvents from 'src/helpers/tealium-events';
import { SalesforceContext } from 'src/context/salesforce-context';
import { AddressForm } from 'src/components/address-form/address-form';
import 'src/containers/onboarding/onboarding.scss';
import './your-directors-address.scss';

export default function YourDirectorAddress(props) {
  const { merchant, setMerchant, customerType } = useContext(SalesforceContext);
  const [selectedAddress, setSelectedAddress] = useState('');

  const textTable = {
    dealer: {
      title: 'What’s the customer’s Directors residential address?',
      subtitle: 'Simply start filling the street address and we’ll do the rest.',
    },
    agent: {
      title: 'What’s the customer’s Directors residential address?',
      subtitle: 'Simply start filling the street address and we’ll do the rest.',
    },
    normal: {
      title: 'What’s your Directors residential address?',
      subtitle: 'Simply start filling in the street address and we’ll do the rest.',
    },
    pos: {
      title: 'What’s your Directors residential address?',
      subtitle: 'Simply start filling in the street address and we’ll do the rest.',
    },
  };

  const getBusinessDetails = () => ({
    street: merchant?.account?.Residential_Street_address_line_1 || '',
    building: merchant?.account?.Residential_Street_address_line_2 || '',
    suburb: merchant?.account?.Residential_Suburb || '',
    city: merchant?.account?.Residential_City_Town || '',
    province: merchant?.account?.Residential_Province || '',
    postalCode: merchant?.account?.Residential_Postal_code || '',
  });

  const setBusinessDetails = (details) => {
    // set wherever these new details need to go
    setMerchant({
      ...merchant,
      account: {
        ...merchant.account,
        Residential_Street_address_line_1: details.street,
        Residential_Street_address_line_2: details.building,
        Residential_Suburb: details.suburb,
        Residential_City_Town: details.city,
        Residential_Province: details.province,
        Residential_Postal_code: details.postalCode,
      },
    });
  };

  return (
    <div className="YourDirectorsAddress" data-testid="YourDirectorsAddress">
      <div className="max-field-width">
        <div className="has-text-centered">
          <h1 className="page-title heading-four title-text">{textTable[customerType].title}</h1>
          <p className="page-title content-normal mobile-width-limit subtext">
            {textTable[customerType].subtitle}
          </p>
        </div>
        <AddressForm
          initialValues={getBusinessDetails()}
          automationPageName={'Your_Directors_Address'}
          dropdownTealiumEvent={() => TealiumEvents.toolAddressUseAutofill(customerType)}
          setValues={setBusinessDetails}
          toggleNext={props.toggleNext}
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
        />
      </div>
    </div>
  );
}
